import Animation from './Animation';

export default function change (e) {
	if (e.detail.id == this.step || this.is_navigating || this.is_breadcrumb_navigation ) return;
	this.step = e.detail.id;

	if (typeof e.detail.anchor != 'undefined' && this.anchor != e.detail.anchor ) {
		this.anchor = e.detail.anchor;
		this.setBreadcrumb();
	}

	if (this.step < 99) {
		this._container.interactiveChildren = false;
		this.boundaries.interactive = false;
		if (typeof this.scatter_container != 'undefined' && typeof this.spare_container != 'undefined') {
			this.spare_container.renderable = false;
			this.scatter_container.renderable = false;
			this.scatterManager.halt();
		}
	} else {
		this.boundaries.renderable = false;
		this.boundaries.interactive = true;
		if (this.layoutManager.zoom_timer._call != null) {
			this._container.interactiveChildren = false;
		} else {
			this._container.interactiveChildren = true;
		}
	}

	if (this.step > 1 && this.step < 99) {
		this.legendOn();
	} else {
		this.legendOff();
	}

	if (~[7,8].indexOf(this.step)) {
		this.scaleOn();
	} else {
		this.scaleOff();
	}

	this.queue.unshift(new Animation(this,
			e.detail.id,
			e.detail.zoom,
			e.detail.layout,
			e.detail.slice,
			this.velocity,
			e.detail.center,
			this.reverse,
			e.detail.offset_x,
			e.detail.offset_y,
			e.detail.min_year,
			e.detail.max_year,
			e.detail.order,
			e.detail.reposition,
			e.detail.image,
			e.detail.caption
			)
		);
}
